const MODULE = 'CLB_AUTHENTICATION'

export const SOCIAL_LOGIN = `${MODULE}/SOCIAL_LOGIN`
export const SOCIAL_LOGIN_SUCCEEDED = `${MODULE}/SOCIAL_LOGIN_SUCCEEDED`
export const SET_AUTHORIZED_USER = `${MODULE}/SET_AUTHORIZED_USER`
